import { render, staticRenderFns } from "./TrInputOnBackgroundV2.vue?vue&type=template&id=646767b5&scoped=true&"
import script from "./TrInputOnBackgroundV2.vue?vue&type=script&lang=js&"
export * from "./TrInputOnBackgroundV2.vue?vue&type=script&lang=js&"
import style0 from "./TrInputOnBackgroundV2.vue?vue&type=style&index=0&id=646767b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646767b5",
  null
  
)

export default component.exports